<template lang="pug">
.d-flex.align-center.flex-wrap(style="gap: 8px")
  filter-date-simple(ref="date" :filter.sync="dateFilter" title="Date")
  filter-type(:filter.sync="typeFilter")
  filter-payment-method-simple(:filter.sync="paymentMethodFilter")
  v-spacer
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterDateSimple from './FilterDateSimple.vue'
import FilterPaymentMethodSimple from './FilterPaymentMethodSimple.vue'
import FilterType from './FilterType.vue'

export default {
  name: 'ConsolidatedEInvoiceFilterRow',
  components: {
    FilterDateSimple,
    FilterPaymentMethodSimple,
    FilterType
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    typeFilter: {},
    dateFilter: {},
    paymentMethodFilter: {},
  }),
  computed: {
    allFilters() {
      const filters = []
      // Handle type filter
      if (this.typeFilter.key) {
        filters.push(this.typeFilter)
      }
      // Handle date filter
      if (this.dateFilter.key) {
        filters.push(this.dateFilter)
      }
      // Handle payment method filter
      if (this.paymentMethodFilter.key) {
        filters.push(this.paymentMethodFilter)
      }
      return filters
    }
  },
  watch: {
    allFilters(newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  methods: {
    resetFilters() {
      this.typeFilter = {}
      this.dateFilter = {}
      this.paymentMethodFilter = {}
    }
  }
}
</script>
